var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LinkButton',{attrs:{"to":_vm.toUrl,"title":_vm.$t('general.edit')}},[_c('b-icon-pencil')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }